import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import StandardMoney from "../../../common/StandardMoney";

const CheckoutItemsFootnote = ({ subTotal, currency }) => (
  <section className="apl-data-table__footnote">
    <section>
      <h4>
        <FormattedMessage {...messages.subtotalDescription} />
      </h4>
    </section>
    <section className="apl-field__currency apl-payment__price">
      <h4>
        <StandardMoney value={subTotal} currency={currency} />
      </h4>
    </section>
  </section>
);

CheckoutItemsFootnote.propTypes = {
  subTotal: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
};

export default CheckoutItemsFootnote;



// WEBPACK FOOTER //
// ./components/employee/shop/checkout/CheckoutItemsFootnote.js